import settings from '@/settings'

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/formaspagamento/cadastrar/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let update = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/formaspagamento/atualizar/?id_forma_pagamento=${id}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}
let deletar = (id, headers) => {
  return fetch(`${settings.apetrusApi}/formaspagamento/apagar/?id_forma_pagamento=${id}`, {
    method: 'DELETE',
    mode: 'cors',
    headers: headers
  })
}

const listFormasPagamento = (pagination) => {
  let url = `${settings.apetrusApi}/formaspagamento/`
  if (pagination) {
    url += `?page=${pagination.page}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default'
  })
}

export default {
  insert,
  update,
  listFormasPagamento,
  deletar
}
